"use strict";

import {trackEvent} from "./trackingGa4/gtm";

export function initInScope ($scope) {
    let $slider = $scope.find('.js-product-detail-img-slider');
    let $sliderNav = $scope.find('.js-product-detail-img-slider__nav');

    if(matchMedia('(max-width: 767px)').matches){
        import('slick-carousel').then(function () {
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                fade: true,
            });

            $slider.on('afterChange', function (event, slick, currentSlide) {
                let data = {
                    "datalayer": {
                        "event": "product_images",
                        "product_images": currentSlide+1
                    }
                }
                trackEvent(data, {debug: false});
            });
        });
    }else{
        $(document).ready()
        import('slick-carousel').then(function () {
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: $sliderNav,
                infinite: true,
            });
            $sliderNav.slick({
                slidesToShow: 6,
                vertical: true,
                asNavFor: $slider,
                dots: false,
                focusOnSelect: true,
                centerMode: false,
                infinite: true,
                nextArrow: '<button type="button" class="btn-no-styling slick-next product-detail-img__slick-button" aria-label="Next"><span class="icon icon-arrow-down"></span></button>',
                prevArrow: '<button type="button" class="btn-no-styling slick-prev product-detail-img__slick-button" aria-label="Previous"><span class="icon icon-arrow-up"></span></button>',
            });
        });
    }
}
